module.exports = "<svg viewBox=\"0 0 11 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.44 0A5.19 5.19 0 0 0 .495 6.767v.003c.163.508.402.982.703 1.41l4.263 8.548 4.23-8.56c.302-.432.543-.91.704-1.426A5.19 5.19 0 0 0 5.44 0zm0 7.724a2.607 2.607 0 1 1 0-5.215 2.607 2.607 0 0 1 0 5.214z\" fill=\"#9A9A9A\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/location-icon.svg
// module id = +xoY
// module chunks = 89